/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const AskIcon = props => {
	const { color = '' } = props

	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='1.8em' height='1.8em' viewBox='0 0 24 24'>
			<g data-name='Group 16334'>
				<g data-name='Ellipse 1515' fill='#fff' stroke={color} strokeWidth={2}>
					<circle cx={11.5} cy={11.5} r={11.5} stroke='none' />
					<circle cx={11.5} cy={11.5} r={10.5} fill='none' />
				</g>
				<path
					data-name='Icon open-question-mark'
					d='M11.473 4.418a4.576 4.576 0 0 0-3.328 1.169A3.863 3.863 0 0 0 7.1 7.853l1.771.23a2.146 2.146 0 0 1 .549-1.222 2.629 2.629 0 0 1 2.054-.673 3.124 3.124 0 0 1 2.16.6 1.48 1.48 0 0 1 .5 1.169c0 1.47-.6 1.877-1.487 2.656a5.047 5.047 0 0 0-2.054 3.984v.443h1.766v-.443c0-1.47.549-1.877 1.434-2.656A5.077 5.077 0 0 0 15.9 7.959a3.4 3.4 0 0 0-1.045-2.5 4.894 4.894 0 0 0-3.382-1.041Zm-.885 12.394v1.771h1.771v-1.771Z'
					fill={color}
				/>
			</g>
		</svg>
	)
}

export default AskIcon
